import React from 'react';
import ReactDOM from 'react-dom';
import IconLabel from 'components/common/IconLabel';
import Map from 'components/common/Map';
import WideP from 'components/common/WideP';
import { pluralize } from 'utils';

function label(name, count) {
  return (
    <div className="line-height-12">
      <span className="d-block d-sm-inline text-center">{count}</span> <span>{pluralize(name, count)}</span>
    </div>
  );
}

export default class ListingGeneralInfo extends React.Component {
  componentDidMount() {
    if (window.innerHeight >= 1200) {
      const el = ReactDOM.findDOMNode(this);
      const item = el.querySelector(".listing-general-info-item:first-child");
      const text = item.querySelector(".wide");
      const offset = text.getBoundingClientRect().left - item.getBoundingClientRect().left;
      item.style.marginLeft = `-${offset}px`;
    }
  }

  render() {
    const { listing } = this.props;
    const { accommodates, bedrooms, beds, bathrooms, address: { full: address }, publicDescription: { summary } } = listing;

    return (
      <div className="mt-sm-6 bg-faded-2 listing-general-info">
        <div className="row no-gutters separator">
          <div className="col-xl p-sm-5 py-5 px-2 listing-general-info-row">
            <div className="d-flex">
              <div className="listing-general-info-item mr-4">
                <IconLabel icon="listing_guests" label={label('guest', accommodates)} wide={true} contained={true}/>
              </div>
              <div className="listing-general-info-item mr-4">
                <IconLabel icon="listing_bedrooms" label={label('bedroom', bedrooms)} wide={true} contained={true}/>
              </div>
              <div className="listing-general-info-item mr-4">
                <IconLabel icon="listing_beds" label={label('bed', beds)} wide={true} contained={true}/>
              </div>
              <div className="listing-general-info-item">
                <IconLabel icon="listing_bathroom" label={label('bathroom', bathrooms)} wide={true} contained={true}/>
              </div>
            </div>
          </div>
          <div className="col-xl p-5 text-center listing-address">
            <IconLabel icon="listing_location" label={address} contained={true}/>
          </div>
        </div>

        <div className="row no-gutters">
          <div className="col p-5">
            <WideP>{summary}</WideP>
          </div>
          <div className="col hidden-md-down">
            <Map markers={[{ listing, position: { lng: listing.address.lng, lat: listing.address.lat }}]} className="listing-map-container"/>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ListingGeneralInfo.js